import React, { useEffect } from 'react';
import { Table, Button, Space, Popconfirm, message, Row, Col } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getAmenities , deleteAmenity } from '../../features/amenitySlice';
import { useNavigate } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';
import    App from  '../../Utils/LayoutMobile'
const AmenityList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {amenities,loading,error} = useSelector((state) => state.amenities);
  
  console.log("::amenities:::",amenities)

  useEffect(() => {
    dispatch(getAmenities());
  }, [dispatch]);

  const handleDelete = async (id) => {
    try {
      await dispatch(deleteAmenity(id)).unwrap();
      message.success('amenities deleted successfully');
      dispatch(getAmenities());
    } catch (err) {
      console.error(err);
      message.error('Failed to delete amenities');
    }
  };
  const columns = [
    {
      title: 'Icon',
      dataIndex: 'icon',
      key: 'icon',
      render: (icon) => (
        icon ? <img src={icon} alt="icon" style={{ width: 40, height: 40 }} /> : 'No Icon'
      ),
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Available',
      dataIndex: 'isAvailable',
      key: 'isAvailable',
      render: (value) => value ? 'Yes' : 'No',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space>
          <Button type="primary" onClick={() => navigate(`/amenity/edit/${record._id}`)}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this amenity?"
            onConfirm={() => handleDelete(record._id)}
            okText="Yes"
            cancelText="No"
          >
            <Button danger type="primary">Delete</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];
  

  return (
    <>
    <App>
      <Row justify="end" style={{ marginBottom: '1rem' }}>
        <Col>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => navigate('/CreateAmenities')}
          >
            amenities
          </Button>
        </Col>
      </Row>

      <Table
        columns={columns}
        dataSource={amenities}
        rowKey="_id"
        loading={loading}
        pagination={{ pageSize: 10 }}
      />
      </App>
    </>
  );
};

export default AmenityList;
